import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export const MAIN_CONTENT_ID = 'main-content';

@Injectable({ providedIn: 'root' })
export class RouteAccessibilityService {
  private readonly router = inject(Router);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  init(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        requestAnimationFrame(() => this.focusMainContent());
      });
  }

  focusMainContent(): void {
    const main = this.document.getElementById(MAIN_CONTENT_ID);
    main?.focus({ preventScroll: true });
  }
}
